import React from 'react';
import { Icon } from 'antd-mobile';
import './index.scss';

interface ISprops {
    [propsName: string]: any;
}
const Empty = (props: ISprops) => {
    return (
        <div className="loading-wrapper">
            <Icon className="loading-icon" type="loading" />
            <span>页面加载中...</span>
        </div>
    );
};
export default Empty;
